import { Capacitor } from '@capacitor/core';

let deepLinkHandler: ((url: string) => void) | null = null;

export async function initNativeOAuth() {
  if (!Capacitor.isNativePlatform()) return;

  const [{ App }, { Browser }] = await Promise.all([
    import('@capacitor/app'),
    import('@capacitor/browser'),
  ]);

  App.addListener('appUrlOpen', (event) => {
    void Browser.close();
    deepLinkHandler?.(event.url);
  });
}

export function onOAuthDeepLink(handler: (url: string) => void) {
  deepLinkHandler = handler;
}

export async function openNativeOAuthLogin(url: string) {
  const { Browser } = await import('@capacitor/browser');
  await Browser.open({ url, presentationStyle: 'popover' });
}

export async function initAppLifecycle(onBackground: () => void, onForeground: () => void) {
  if (!Capacitor.isNativePlatform()) {
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'hidden') onBackground();
      else onForeground();
    });
    window.addEventListener('pagehide', onBackground);
    return;
  }

  const { App } = await import('@capacitor/app');
  App.addListener('appStateChange', ({ isActive }) => {
    if (isActive) onForeground();
    else onBackground();
  });
}
